import { graphql, compose } from "react-apollo";
import {
  DELETE_LEAD_NOTE,
  DELETE_PROSPECT_NOTE,
  DELETE_REALTOR_NOTE,
  DELETE_HOMEOWNER_NOTE,
  DELETE_MARKETING_ONLY_NOTE,
} from "../../graphql/mutations";
import NoteList from "./notes-list";

const NoteListView = compose(
  graphql(DELETE_LEAD_NOTE, { name: "deleteLeadNote" }),
  graphql(DELETE_REALTOR_NOTE, { name: "deleteRealtorNote" }),
  graphql(DELETE_HOMEOWNER_NOTE, { name: "deleteHomeownerNote" }),
  graphql(DELETE_PROSPECT_NOTE, { name: "deleteProspectNote" }),
  graphql(DELETE_MARKETING_ONLY_NOTE, { name: "deleteMarketingOnlyNote" })
)(NoteList);
export default NoteListView;
